(function ($) {
    'use strict';

    var $gallery = $('.conference-gallery');
    var $showMoreBtn = $gallery.find('.show-more');

    $showMoreBtn.click(function(e) {
        e.preventDefault();

        var pageId = $(this).data('page-id');
        var offset = $gallery.find('.container .gallery-grid a').length;

        $.get(window.wp.ajaxUrl + '?action=load_gallery_items&offset=' + offset + '&page_id=' + pageId, function (response) {
            var items = response.items;

            var appendData = '';

            items.forEach(function (item) {
                appendData += '<a href="' + item.url + '" class="gal-item fancybox" rel="gallery1"' +
                    ' style="background-image: url(' + item.thumbnail_url + ')"></a>';
            });

            $gallery.find('.container .gallery-grid').append(appendData);

            if (response.end) {
                $showMoreBtn.remove();
            }
        })
    });
})(jQuery);